import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ac_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 from any API call, the JWT has expired or been invalidated.
// Clear it and bounce the user back to /login so they can sign in again.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Don't redirect on the login endpoint itself (so wrong-password errors render in the form).
    if (status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem("ac_token");
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.replace(`/login?next=${next}&expired=1`);
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Prefix a relative backend URL (/api/files/...) with the public backend origin,
// so uploaded media renders in <img>/<video> tags regardless of origin.
export function resolveMediaUrl(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

// Normalize a post's categories — supports legacy single-`category` and new array `categories`.
export function postCategories(post) {
  if (!post) return [];
  if (Array.isArray(post.categories)) return post.categories.filter(Boolean);
  if (post.category) return [post.category];
  return [];
}

export function primaryCategory(post) {
  const cats = postCategories(post);
  return cats[0] || "General";
}
